function r(r,t){function n(){return!n.pred.apply(n.thisArg,arguments)}return n.pred=r,n.thisArg=t,n}export{r as not};
